import * as React from "react";
import { connect } from "react-redux";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { RowData, Table, TableData } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { ErrorLevelDisplay } from "../../../../../store/Policies/Displays";
import { BusinessRuleViolation, ErrorLevel } from "../../../../../store/Policies/Types";
import { ThemeBreakpoints, ThemePalette, ThemePaletteState, ThemeShadowSizes } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalClose } from "../../../../../utils/redux/ActionTypes";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";


/**
 *
 */
interface OwnProps {
    modalID: string;
    id: string;
    violations: BusinessRuleViolation[];
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps;

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
});

/**
 *
 */
export class ErrorDetailModalComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.state = {};
        this.closeModal = this.closeModal.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }

    public render() {
        return (
            <FlexColumn>
                <FlexRow isFixed>
                    <Navbar
                        theme={{
                            palette: ThemePalette.BRAND_ACCENT,
                        }}
                    >
                        <NavbarStack>
                            <NavbarStackContent>
                                <NavbarTitle>
                                    Error description log
                                </NavbarTitle>
                            </NavbarStackContent>
                            <NavbarStackRight>
                                <NavbarIcon>
                                    <Button
                                        icon={IconNames.TIMES}
                                        link={{ onClick: this.closeModal() }}
                                    />
                                </NavbarIcon>
                            </NavbarStackRight>
                        </NavbarStack>
                    </Navbar>
                </FlexRow>
                <FlexRow
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                    }}
                >
                    <FlexColumn>
                        <FlexRow isScrollable >
                            <FillUp>
                                <Table
                                    hasActions
                                    data={{
                                        columns: this.resultsData().columns,
                                        rows: this.resultsData().rows,
                                        sort: this.resultsData().sort,
                                    }}
                                />
                            </FillUp>
                        </FlexRow>
                    </FlexColumn>
                </FlexRow>
                <FlexRow isFixed>
                    <FlexColumn
                        theme={{
                            palette: ThemePalette.CONTRAST_PRIMARY,
                        }}
                    >
                        <Container
                            theme={{
                                padding: { "": { y: 3 } },
                            }}
                        >
                            <ButtonsWrapper
                                defaultOrientation={Orientation.HORIZONTAL}
                                orientations={{
                                    [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                    [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                }}
                                alignment={Alignment.RIGHT}
                            >
                                <Button
                                    theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                    link={{ onClick: this.closeModal() }}
                                >
                                    Close
                                </Button>
                            </ButtonsWrapper>
                        </Container>
                    </FlexColumn>
                </FlexRow>
            </FlexColumn >
        );
    }

    private closeModal() {
        return () => this.props.closeModal(this.props.modalID);
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.violations.map((row, index) => ({
            id: row.id,
            data: [
                row.errorDescription,
                (
                    <Badge
                        key={`p-badge-${index}`}
                        theme={{
                            paletteState:
                                row.errorLevel === ErrorLevel.CRITICAL
                                    ? ThemePaletteState.DANGER
                                    : ThemePaletteState.WARNING,
                            shadow: ThemeShadowSizes.TINY,
                        }}
                    >
                        {ErrorLevelDisplay[row.errorLevel]}
                    </Badge>
                ),
            ],
        }));
    }

    /**
     *
     */
    private resultsData(): TableData {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Error description",
                },
                {
                    label: "Error level",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const ErrorDetailModal = connect(
    undefined,
    mapDispatchToProps,
)(ErrorDetailModalComp);
